import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _toConsumableArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// src/lib.tsx
import { isMatch } from "lodash-es";
function mergeExecutors(oldExecutors, newExecutors) {
  return [].concat(_toConsumableArray(oldExecutors), _toConsumableArray(newExecutors));
}
function matchVariables(matcher, variables) {
  if (typeof matcher === "undefined") {
    return true;
  }
  if (typeof matcher === "function") {
    return matcher(variables);
  }
  return isMatch(variables, matcher);
}
function formatEntry(id, variables) {
  return "".concat(id ? id : "*", ":").concat(variables ? JSON.stringify(variables) : "*");
}
function findExecutors(registry, id, variables) {
  return registry.filter(function (entry) {
    return (id === entry.id || entry.id === void 0) && matchVariables(entry.variables, variables);
  }).map(function (entry) {
    return entry.executor;
  });
}
function findExecutor(registry, id, variables) {
  var result = findExecutors(registry, id, variables);
  if (result.length > 0) {
    return result.pop();
  }
  throw new ExecutorRegistryError(registry, id, variables);
}
var ExecutorRegistryError = /*#__PURE__*/function (_Error) {
  _inherits(ExecutorRegistryError, _Error);
  var _super = _createSuper(ExecutorRegistryError);
  function ExecutorRegistryError(registry, id, variables) {
    var _this;
    _classCallCheck(this, ExecutorRegistryError);
    var candidates = registry.filter(function (entry) {
      return id === entry.id;
    });
    var candidatesMessage = candidates.length > 0 ? ["Candidates:"].concat(_toConsumableArray(candidates.map(function (_ref) {
      var id2 = _ref.id,
        variables2 = _ref.variables;
      return formatEntry(id2, variables2);
    }))) : [];
    _this = _super.call(this, ["No executor found for:", formatEntry(id, variables)].concat(_toConsumableArray(candidatesMessage)).join(" "));
    _this.name = "ExecutorRegistryError";
    return _this;
  }
  return _createClass(ExecutorRegistryError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { mergeExecutors, findExecutors, findExecutor };